import React, { useCallback } from "react";
import { AHSeparator, Dialog, ListItem, TodoPrioIcon } from "arkh";
import { ScrollView } from "react-native";
import { graphql, useFragment } from "react-relay";

import { PRIORITIES } from "widgets/src/Todo/TodoPriorities";

import { onPressInHaptic } from "widgets/src/onPressInHaptic";

import { useTodoEditSetPrio } from "./useTodoEditSetPrio";
import {
  TodoEditPrioPopover_todo$key,
  TodoPriority,
} from "./__generated__/TodoEditPrioPopover_todo.graphql";
import { FormattedMessage } from "react-intl";

export function TodoEditPrioPopoverComponent(props: {
  prio: TodoPriority;
  setPrio: (prio: TodoPriority) => void;
  visible: boolean;
  onClose: () => void;
}) {
  const renderItem = useCallback(
    (prio: (typeof PRIORITIES)[number], index: number) => {
      const selected = props.prio === prio.value;
      return (
        <React.Fragment key={prio.value}>
          {index > 0 ? <AHSeparator /> : null}
          <ListItem
            right={selected ? <ListItem.Check /> : null}
            left={<TodoPrioIcon priority={prio.value} />}
            onPress={() => {
              onPressInHaptic();
              props.setPrio(prio.value);
            }}
          >
            <ListItem.Title color="text-primary">{prio.label}</ListItem.Title>
          </ListItem>
        </React.Fragment>
      );
    },
    [props]
  );

  return (
    <Dialog
      visible={props.visible}
      onClose={props.onClose}
      minHeight={400}
      title={
        <FormattedMessage
          description="Todo Priority Title"
          defaultMessage="Priority"
        />
      }
    >
      <ScrollView style={{ flex: 1 }}>{PRIORITIES.map(renderItem)}</ScrollView>
    </Dialog>
  );
}

export function TodoEditPrioPopover(props: {
  todo: TodoEditPrioPopover_todo$key;
  visible: boolean;
  onClose: () => void;
  currentEmployeeId: string | null;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoEditPrioPopover_todo on Todo {
        id
        priority
        ...useTodoEditSetPrio_todo
      }
    `,
    props.todo
  );

  const [savePrio] = useTodoEditSetPrio(todo, props.currentEmployeeId);

  return (
    <TodoEditPrioPopoverComponent
      visible={props.visible}
      onClose={props.onClose}
      prio={todo.priority}
      setPrio={savePrio}
    />
  );
}
